export enum AvailableErrorLogTypes {
  INVALID_ACCESS_KEY = 'invalid_access_key',
  GENERIC = 'generic_error'
}
